module.exports = __webpack_public_path__ + "img/2.1439c8f4.jpg";